import React, { Fragment, useEffect, useMemo, useState } from 'react'
import { useDispatch } from 'react-redux';
import { GetLocalStorage } from '../../commonClass/Session';
import { postUsersData } from '../../../services/ApiCallingUserServices';
import RichTextBox from '../../../customControl/RichTextBox';

function TermsCondition({ termsData, userRights, setUpdateFetch }) {
    const dispatch = useDispatch();

    const [errorMessage, setErrorMessage] = useState({})
    const [subTab, setSubTab] = useState(1); // 1 for Customer UI, 3 for Mid Office
    const [termAndCondition, setTermAndCondition] = useState({
        Description: '',
        IsActive: true,
        TermsConditionId: 0,
        UserType: 1
    });
    const [termRef, setTermRef] = useState(null);
    const [richboxheight, setRichBoxHeight] = useState(false);
    const [disabled, setDisabled] = useState(false);

    useEffect(() => {
        const currentData = termsData?.find(x => x.UserType === subTab);
        setTermAndCondition({
            ...termAndCondition,
            Description: currentData?.Description || '',
            TermsConditionId: currentData?.TermsConditionId || 0,
            UserType: subTab
        })
        setErrorMessage({})
    }, [termsData, subTab])

    const getPlainText = (html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        return doc.body.textContent || "";
    }

    const isValidData = () => {
        let isValid = true;
        let ErrorMessa = {};

        const plainText = getPlainText(termAndCondition?.Description || "");

        if (plainText?.trim()?.length <= 0) {
            ErrorMessa['termsconditions'] = 'Can not leave blank, input is mandatory.'
            isValid = false
        } else if (plainText?.trim()?.length > 2000) {
            ErrorMessa['termsconditions'] = 'Character limit exceeded. Maximum 2000 characters allowed.'
            isValid = false
        }

        setErrorMessage(ErrorMessa)
        return isValid
    }

    const handleAddClick = async (data) => {

        if (isValidData()) {
            const userdata = GetLocalStorage()
            const URL = 'insertTermsConditions'
            const updateAndSave = await postUsersData(`/master/v1/${URL}`, {
                ...data, IsActive: true,
                UserId: userdata?.userMasterID,
                UserType: subTab
            })

            if (updateAndSave.status) {
                setUpdateFetch(true)
                dispatch({ type: 'ALERTING', message: updateAndSave.message })
                setErrorMessage({})
            } else {
                dispatch({ type: 'ALERTING', message: updateAndSave.message })
            }
        }
    }

    const handleClearClick = () => {
        const clearedData = {
            ...termAndCondition,
            Description: "",
        };
        setTermAndCondition(clearedData);

        if (termRef?.current) {
            termRef.current.value = ''; // clear the content
        }
        setErrorMessage({})
    }

    const handleOnChange = (value) => {
        termAndCondition.Description = value; // Keep for immediate access if needed
    }

    const handleOnBlur = (value) => {
        setTermAndCondition(prev => ({
            ...prev,
            Description: value
        }));
    }

    const answerconfig = useMemo(() => ({
        readonly: false,
        maxHeight: richboxheight === true ? 400 : 600,
        width: '100%',
        statusbar: false,
        disablePlugins: ["source"],
        removeButtons: ["about", "image", "link", "select", "video"],
        toolbarAdaptive: false,
        defaultMode: "1",
        disabled: disabled
    }), [disabled, richboxheight]);

    return (
        <Fragment>
            <div className="container-fluid mt-4 heading_color d-flex justify-content-between align-items-center mb-2">
                <h3>Terms & Conditions</h3>
                <div className="premium-tabs-container mb-0">
                    {/* here we pass 1 and 3 for customer and mid office, also this value pass in API */}
                    <button
                        className={`premium-tab-btn ${subTab === 1 ? 'active' : ''}`}
                        onClick={() => setSubTab(1)}
                        type="button"
                    >
                        <i className="fa-solid fa-display"></i>
                        Customer UI
                    </button>
                    <button
                        className={`premium-tab-btn ${subTab === 3 ? 'active' : ''}`}
                        onClick={() => setSubTab(3)}
                        type="button"
                    >
                        <i className="fa-solid fa-building-user"></i>
                        Mid Office
                    </button>
                </div>
            </div>

            <div className='row m-0'>
                <div className="col-lg-3 col-md-12 col-sm-12 mb-lg-1">
                    <label htmlFor="Answer" className="col-form-label required">Type something</label>
                </div>

                <div className=" col-lg-9 col-md-12 col-sm-12 mb-lg-1">
                    <RichTextBox
                        field={`TermsConditions_${subTab === 1 ? 'customer' : 'midOffice'}`}
                        fieldvalue={termAndCondition.Description}
                        tabIndex={4}
                        OnChangeofRichBox={handleOnChange}
                        onBlur={handleOnBlur}
                        textconfig={answerconfig}
                        setRef={setTermRef}
                    />
                    <div className="d-flex justify-content-between">
                        <small className="text-muted">Max 2000 characters</small>
                    </div>

                    {errorMessage?.termsconditions &&
                        <div className="text-start text-danger"> {errorMessage?.termsconditions} </div>
                    }
                </div>
            </div>

            <div className="d-flex justify-content-center mt-4">
                <button type="button" class="btn btn-primary mx-1" id="btnAdd"
                    onClick={() => handleAddClick(termAndCondition)}
                    disabled={!userRights?.URightAdd || !userRights?.URightEdit}
                >Add</button>
                {/* <button type="button" className="btn btn-primary mx-1" id="btnAdd" onClick={handleAddClick} disabled={editdisabled ? false : true}>{buttonaddeditText}</button>} */}
                <button type="button" className="btn btn-primary mx-1" id="btnClear"
                    onClick={() => handleClearClick()}
                >Clear</button>
            </div>
        </Fragment>
    )
}

export default TermsCondition
